import { defineMessages } from 'react-intl';

export default defineMessages({
  roomsAbrev: {
    id: 'global_rooms_abrev',
    defaultMessage: 'Bed/s',
    description: 'homes',
  },
  bathroomsAbrev: {
    id: 'global_bathrooms_abrev',
    defaultMessage: 'Bath',
    description: 'homes',
  },
  areaMetric: {
    id: 'global_floor_area_metric_short',
    defaultMessage: 'ft²',
    description: 'homes',
  },
});



// WEBPACK FOOTER //
// ./app/components/mobile/Features/homes/messages.js